class GRAnnouncement extends HTMLElement {
  connectedCallback() {
    this.messages = [...this.querySelectorAll('.gr-home-announcement__message')];
    this.mobile = window.matchMedia('(max-width: 767px)');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.index = Math.max(0, this.messages.findIndex((message) => message.classList.contains('is-active')));
    this.handleMediaChange = () => this.updateRotation();
    this.mobile.addEventListener('change', this.handleMediaChange);
    this.reducedMotion.addEventListener('change', this.handleMediaChange);
    this.updateRotation();
  }

  updateRotation() {
    window.clearInterval(this.timer);
    if (this.messages.length < 2 || this.dataset.rotate !== 'true' || !this.mobile.matches || this.reducedMotion.matches) return;
    this.timer = window.setInterval(() => {
      this.messages[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.messages.length;
      this.messages[this.index].classList.add('is-active');
    }, Number(this.dataset.interval) || 5000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
    this.mobile?.removeEventListener('change', this.handleMediaChange);
    this.reducedMotion?.removeEventListener('change', this.handleMediaChange);
  }
}

if (!customElements.get('gr-announcement')) customElements.define('gr-announcement', GRAnnouncement);

const closeNavigation = (toggle) => {
  const navigation = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!navigation) return;
  toggle.setAttribute('aria-expanded', 'false');
  toggle.querySelector('.visually-hidden').textContent = 'Open menu';
  navigation.classList.remove('is-open');
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.gr-home-header__toggle');
  if (toggle) {
    const navigation = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!navigation) return;
    const opening = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(opening));
    toggle.querySelector('.visually-hidden').textContent = opening ? 'Close menu' : 'Open menu';
    navigation.classList.toggle('is-open', opening);
    return;
  }

  document.querySelectorAll('.gr-home-header__toggle[aria-expanded="true"]').forEach((openToggle) => {
    if (!event.target.closest('.gr-home-header')) closeNavigation(openToggle);
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.gr-home-header__toggle[aria-expanded="true"]').forEach((toggle) => {
      closeNavigation(toggle);
      toggle.focus();
    });
    return;
  }

  const carousel = event.target.closest('[data-gr-carousel]');
  if (event.target.closest('input, select, textarea, button, a')) return;
  if (!carousel || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
  event.preventDefault();
  const firstItem = carousel.firstElementChild;
  const step = firstItem ? firstItem.getBoundingClientRect().width : carousel.clientWidth;
  carousel.scrollBy({ left: event.key === 'ArrowRight' ? step : -step, behavior: 'smooth' });
});

const autoplayCarousels = () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-gr-carousel][data-autoplay="true"]').forEach((carousel) => {
    if (carousel.dataset.autoplayReady === 'true') return;
    carousel.dataset.autoplayReady = 'true';
    const advance = () => {
      if (carousel.matches(':hover, :focus-within') || carousel.scrollWidth <= carousel.clientWidth) return;
      const firstItem = carousel.firstElementChild;
      const step = firstItem ? firstItem.getBoundingClientRect().width : carousel.clientWidth;
      const atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2;
      carousel.scrollTo({ left: atEnd ? 0 : carousel.scrollLeft + step, behavior: 'smooth' });
    };
    carousel.grAutoplayTimer = window.setInterval(advance, 5000);
  });
};

autoplayCarousels();
document.addEventListener('shopify:section:load', autoplayCarousels);
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-gr-carousel]').forEach((carousel) => window.clearInterval(carousel.grAutoplayTimer));
});
